import {module} from 'modujs';
import * as CookieConsent from 'vanilla-cookieconsent';

export default class extends module {
    constructor(m) {
        super(m);

        this.$el = this.el;
        var opts = this.$el.getAttribute('data-cookie-consent-options');

        try {
            this.cookieConfig = JSON.parse(opts);
        } catch (e) {
            console.warn(e.message);
        }

        this.cookieConfig.categories = this.prepareCategories(this.cookieConfig.categories);

        CookieConsent.run(this.cookieConfig);
    }

    prepareCategories(categories) {
        for (const [categoryName, categoryData] of Object.entries(categories)) {
            if (
                categoryData?.autoClear?.cookies &&
                Array.isArray(categoryData.autoClear.cookies) &&
                categoryData.autoClear.cookies.length > 0
            ) {
                categoryData.autoClear.cookies.map((cookie) => {
                    if (
                        cookie?.name &&
                        typeof cookie.name === 'string'
                    ) {
                        const found = cookie.name.match(/^\/(.+)\/([a-z]+)?$/);
                        if (found) {
                            cookie.name = new RegExp(found[1], found[2]);
                        }
                    }

                    return cookie;
                });

                categories[categoryName].autoClear.cookies = categoryData.autoClear.cookies;
            }
        }

        return categories;
    }

    init() {
        document.addEventListener("click", event => {
            let target = event.target;
            while (target && target !== document) {
                if (target.matches('a')) {
                    if (target.getAttribute('href') === '#show-cookie-preferences') {
                        event.preventDefault();
                        event.stopPropagation();
                        CookieConsent.showPreferences();
                    } else if (target.getAttribute('data-cookie-consent') === 'hide') {
                        CookieConsent.hidePreferences();
                        CookieConsent.hide();
                    }

                    break;
                }
                target = target.parentNode;
            }
        }, false);
    }
}
